import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, ArrowRight, LayoutDashboard } from "lucide-react";
import { SearchButton } from "@/components/catalog/ProductSearch";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { Logo } from "@/components/common/Logo";
import { useAuth } from "@/context/AuthContext";

export const NAV = [
  { to: "/solutions", label: "Solutions" },
  { to: "/amc", label: "AMC" },
  { to: "/projects", label: "Projects" },
  { to: "/blog", label: "Blog" },
  { to: "/industries", label: "Industries" },
  { to: "/compliance", label: "Compliance" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

const linkCls = ({ isActive }) =>
  `relative whitespace-nowrap text-sm font-medium transition-colors ${isActive ? "text-[#C20500]" : "text-slate-700 hover:text-slate-950"}`;

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const portalTo = user ? (user.role === "admin" ? "/admin" : "/portal") : "/login";

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/70 bg-white/80 backdrop-blur-xl" data-testid="site-navbar">
      <div className="container-x flex h-16 items-center justify-between gap-4 2xl:gap-6">
        <Logo />
        <nav className="hidden items-center gap-4 xl:flex 2xl:gap-6">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={linkCls} data-testid={`nav-${n.label.toLowerCase()}-link`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden items-center gap-2 xl:flex">
          <SearchButton />
          <Link to={portalTo} className="btn-outline whitespace-nowrap py-2" data-testid="nav-portal-link">
            <LayoutDashboard className="h-4 w-4" /> {user ? "My Portal" : "Vendor Portal"}
          </Link>
          <Link to="/enquiry" className="btn-primary whitespace-nowrap py-2.5" data-testid="nav-bulk-enquiry-button">
            Get a quote <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
        <div className="ml-auto flex items-center gap-1 xl:hidden"><SearchButton mobile /></div>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button className="rounded-md p-2 text-slate-800 xl:hidden" aria-label="Open menu" data-testid="nav-mobile-menu-button">
              <Menu className="h-6 w-6" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[300px]">
            <SheetTitle className="sr-only">Menu</SheetTitle>
            <div className="mt-8 flex flex-col gap-1">
              {NAV.map((n) => (
                <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)} className="rounded-md px-3 py-3 text-base font-medium text-slate-800 hover:bg-slate-100" data-testid={`mobile-nav-${n.label.toLowerCase()}-link`}>
                  {n.label}
                </NavLink>
              ))}
              <Link to={portalTo} onClick={() => setOpen(false)} className="btn-outline mt-4" data-testid="mobile-nav-portal-link">
                {user ? "My Portal" : "Vendor Portal Login"}
              </Link>
              <Link to="/enquiry" onClick={() => setOpen(false)} className="btn-primary mt-2" data-testid="mobile-nav-enquiry-button">
                Get a quote
              </Link>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};
